import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';

@Component({
    selector: 'labels-dialog',
    templateUrl: 'labels.component.html',
    styleUrls: ['labels.component.css']
  })
  export class LabelsDialog {

    samples;
    oldSamples;
    myWebSocket: WebSocketSubject<any> = webSocket('ws://localhost:1337');

    constructor(
        public dialogRef: MatDialogRef<LabelsDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

            console.log(data)
            this.samples = this.data.samples;
            console.log(this.samples)

            this.oldSamples = this.data.oldSamples;
            /*let lastLabel = "";
            let test;
            let lastId = 0;
            for(let i=0; i < this.samples.length; ++i){
                if(this.samples[i].labelId != lastLabel){
                    lastLabel = this.samples[i].labelId;
                    test = this.samples[i].testId;
                    this.samples[i].testId = new Array();
                    this.samples[i].testId.push(test)
                    lastId = i;
                } else{
                    this.samples[lastId].testId.push(this.samples[i].testId);
                    delete this.samples[i];
                }
            }*/

            this.samples = this.samples.filter( sample => sample!=undefined)
            this.myWebSocket.asObservable().subscribe(dataFromServer => console.log(dataFromServer));

        }

    printLabel(sample){

        console.log(sample)

        this.myWebSocket.next({message: JSON.stringify(sample)});
        
    }

    isNew(sample){
        if(this.oldSamples){
            return this.oldSamples.filter(oldSample => oldSample.labelId == sample.labelId).length == 0
        } else{
            return false;
        }
    }

  }